<template>
    <div class="card p-3 px-2 px-lg-6 mb-3">
        <h1 class="h2 t-orange ml-12px mb-3">Personal Details</h1>
        <form method="POST" class="form">
            <div v-if="errors && Array.isArray(errors)" class="errors mb-4">
                <template v-for="(field) in errors">
                    <div v-for="(error) in field" class="error">{{error}}</div>
                </template>
            </div>
            <div class="account-details d-flex flex-column justify-content-center">
                <div class="columns">
                    <div class="column is-half">
                        <div class="field mb-4" :class="{ 'has-error': $v.form.fullName.$error }">
                            <label class="label mb-1" for="fullName">Full Name*</label>
                            <div class="control">
                                <input id="fullName" name="full_name" class="input" type="text"
                                       v-model.trim="$v.form.fullName.$model"/>
                            </div>
                            <div class="error" v-if="$v.$dirty && $v.form.fullName.$error">
                                {{getErrorMessage($v.form.fullName)}}
                            </div>
                        </div>
                    </div>
                    <div class="column is-half">
                        <div class="field mb-4" :class="{ 'has-error': $v.form.email.$error }">
                            <label class="label mb-1" for="email">Email Address*</label>
                            <div class="control">
                                <input id="email" name="email" class="input" type="email"
                                       v-model.trim="$v.form.email.$model"/>
                            </div>
                            <div class="error" v-if="$v.$dirty && $v.form.email.$error">
                                {{getErrorMessage($v.form.email)}}
                            </div>
                        </div>
                    </div>
                </div>
                <input type="hidden" v-model="$v.form.userId" />
                <div class="field d-md-flex justify-content-end px-2 mb-2">
                    <button v-if="!loading" @click.prevent="submit()" class="btn btn-form">
                        Update Profile
                    </button>
                    <pulse-loader v-if="loading" :loading="true" :color="'#E57722'"
                                  :size="'20px'"></pulse-loader>
                </div>
                <div v-if="updated" class="alert alert-success">Profile successfully updated</div>
                <div v-if="errors && !Array.isArray(errors)" class="alert alert-error">{{errors}}</div>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {email, required} from "vuelidate/lib/validators";
    import {axiosApi, axiosWeb} from "@/js/axios";
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        name: 'CatUxoProfileAdvertisement',
        components: {
            PulseLoader,
        },
        props: {
            user: {
                type: Object,
                required: true
            }
        },
        data: function () {
            return {
                form: {
                    csrfToken: null,
                    userId: this.user.id,
                    fullName: this.user.name,
                    email: this.user.email,
                },
                countries: [],
                loading: false,
                errors: [],
                updated: null,
            }
        },
        computed: {
            ...mapGetters('form', [
                'getErrorMessage'
            ]),
            rules() {
                return {
                    fullName: {
                        required,
                    },
                    email: {
                        required,
                        email,
                    }
                }
            },
        },
        methods: {
            fetchCountries() {
                return axiosApi.get(`/api/v1/countries`)
                    .then(response => {
                        if (response.data) {
                            this.countries = response.data.data
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            submit() {
                let $this = this;
                $this.$v.form.$touch();
                if ($this.$v.form.$invalid) return;

                $this.errors = [];

                // Display the loading on the button
                $this.loading = true;

                // Subscribe the user
                return axiosWeb.post(`/api/v1/update-profile/${$this.user.id}`, $this.form).then(response => {
                    $this.loading = false;

                    if (response.status === 200) {
                        $this.updated = true;

                        setTimeout(() => this.updated = false, 3000);
                    }

                }).catch((error) => {
                    $this.loading = false;

                    if (error.response.status === 422) {
                        $this.errors = error.response.data.errors;
                    }

                    if (error.response.status === 500) {
                        $this.errors = 'Profile could not be updated. Please try again.';
                        setTimeout(() => this.errors = false, 3000);
                    }
                })
            }
        },
        created() {
            this.csrfToken = document.querySelector('meta[name="csrf-token"]').content;
            this.fetchCountries();
        },
        validations() {
            return {
                form: this.rules
            }
        },
        mounted() {

        }
    }
</script>

<style lang="scss" scoped>
    @include media-breakpoint-down(sm) {
        .btn,
        .btn-form {
            width: 100%;
            max-width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/pages/settings/ProfileAdvertisement.vue